import React from 'react';

export default class FormInputText1 extends React.Component {

	constructor (props) {
    super(props);
    this.name= this.props.data.name;
    this.nameKr= this.props.data.nameKr;
    this.targetElem= React.createRef();
    console.dir(props)
  }

  componentDidMount () {
    this.props.onCreateRef(this.name, this.targetElem.current);
  }

  handler= (name, e)=> {
    console.log(e.target.value)
    // const regexp = /^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$/;
    let regexp;
    if( name == 'trial_ios')
      regexp = /^([a-zA-Z0-9]([-a-zA-Z0-9]{0,61}[a-zA-Z0-9])?\.)?([a-zA-Z0-9]{1,2}([-a-zA-Z0-9]{0,252}[a-zA-Z0-9])?)\.([-a-zA-Z]{2,63})$/;
    if( name == 'trial_android')
      regexp = /^([a-zA-Z0-9]([_a-zA-Z0-9]{0,61}[a-zA-Z0-9])?\.)?([a-zA-Z0-9]{1,2}([_a-zA-Z0-9]{0,252}[a-zA-Z0-9])?)\.([_a-zA-Z]{2,63})$/;
      
    const match= regexp.test(e.target.value);
    console.log(match)
    this.props.setData(this.name, {
      validity: match,
      value: e.target.value 
    });
  }
  
	render () {
		return (

      <div 
        ref={this.targetElem}
        className="bd-ani-target bd-tr w100 mg-h10"
      >
        <div className="flx-cl m-flx-col">
          <label className="w190p txt-right pd-r15 m-w100 m-txt-left">
            {
              this.props.data.require == true &&
              <span className="ft-rd ft-bi">* </span>
            }
            <span className="ft4 ft-md m-ft35">{this.nameKr}</span>
            
          </label>
          <input 
            onChange={this.handler.bind(null, this.name)} 
            type={this.props.type || 'text' }
            name={this.name} 
            title={this.nameKr}
            value={ this.props.data.value }
            readOnly={this.props.fix || false}
            placeholder={this.props.data.placeholder || `${this.nameKr}`}
            maxLength={this.props.maxLen || 50}
            className=
              {`${this.props.fix && 'ft-gr '}data data-item flx-itm-r w100 pd-10 ft4 m-ft35 bd-dg m-pd-7`}
          />
        </div>
        <p className="txt-right ft5 ft-rd">
          {!this.props.data.validity && !this.props.data.value == '' && '유효성 에러'}
        </p>
			</div>

		);
	}

}